export const limits = {
  PASSWORD: 6,
  FULL_NAME: 3,
  PHONE_MIN: 7,
  PHONE_MAX: 15,
  HOURS_MIN: 0,
  HOURS_MAX: 23
};
